import React from "react";
import ReactDOM from "react-dom";
import styles from "./FullScreenModal.module.css";

export default function FullScreenModal({ children }) {
  return ReactDOM.createPortal(
    <div className={styles.modalover}>
      <div className={styles.modalPopup}>
        {children}
      </div>
    </div>,
    document.body // 👈 rendu direct dans <body>
  );
}
